import React, {useState} from 'react';
import { useFormContext } from './Provider';
import Loading from '../Loading';
import { useModalContext } from '../Modal/Provider';
import { classNames, plural } from '../../Services/helpers';

const Actions = ({submit, cancel, extra, left, leftExtra}) => {
    const {isSubmitting, setFormData, formDisabled, isValidating, isValid, invalidFields} = useFormContext();
    const modalContext = useModalContext();
    const [extraLoading, setExtraLoading] = useState(false);
    const [leftExtraLoading, setLeftExtraLoading] = useState(false);

    let _submit = null;
    if (submit === true) {
        _submit = {
            label: 'Submit',
            btnRef: null,
        }
    } else if (submit) {
        _submit = submit;
    }

    const handleCancel = (e) => {
        e.preventDefault();
        if (cancel.back) {
            window.history.back();
        } else if (cancel.clear) {
            setFormData({});
        } else if (cancel.onClick) {
            cancel.onClick();
        }
        if (modalContext) {
            modalContext.closeModal();
        }
    }

    const handleExtra = (e) => {
        e.preventDefault();
        if (extra.onClick) {
            setExtraLoading(true);
            const extraPromise = extra.onClick();
            Promise.resolve(extraPromise).then(() => {
                if (extra.closeModal && modalContext) {
                    modalContext.closeModal();
                }
                setExtraLoading(false);
            });
        }
    }

    const handleLeftExtra = (e) => {
        e.preventDefault();
        if (leftExtra.onClick) {
            setLeftExtraLoading(true);
            const leftExtraPromise = leftExtra.onClick();
            Promise.resolve(leftExtraPromise).then(() => {
                if (leftExtra.closeModal && modalContext) {
                    modalContext.closeModal();
                }
                setLeftExtraLoading(false)
            });
        }
    }

    const anyActioning = isSubmitting || extraLoading || leftExtraLoading || formDisabled;

    return <>
        <div className="flex flex-row justify-between items-center">
            <div>
                {(leftExtra && !leftExtra?.hide) && <button type="button"
                    ref={leftExtra.btnRef}
                    className={classNames('my-3 mr-3 btn', leftExtra.className)}
                    disabled={leftExtra.disabled || anyActioning}
                    onClick={handleLeftExtra}
                >
                    {leftExtraLoading && <Loading className="mr-2" />}
                    {leftExtra.label}
                </button>}

                {left}
            </div>
            <div>
                {(extra && !extra?.hide) && <button type="button"
                    ref={extra.btnRef}
                    className={classNames('my-3 ml-3 btn', extra.className)}
                    disabled={extra.disabled || anyActioning}
                    onClick={handleExtra}
                >
                    {extraLoading && <Loading className="mr-2" />}
                    {extra.label}
                </button>}

                {cancel && <button type="button"
                    ref={cancel.btnRef}
                    className="my-3 ml-3 btn btn-secondary"
                    disabled={anyActioning || cancel.disabled}
                    onClick={handleCancel}
                >
                    {cancel.label ?? 'Cancel'}
                </button>}

                {_submit && <button type="submit"
                    ref={_submit.btnRef}
                    className="my-3 ml-3 btn btn-primary"
                    disabled={anyActioning || _submit.disabled || (isValidating && !isValid)}
                >
                    {isSubmitting && <Loading className="mr-2" bg="dark" />}
                    {submitLabel(_submit, isSubmitting)}
                </button>}
            </div>
        </div>
        {(isValidating && !isValid) && <div className="-mt-3 text-right text-xs text-red-500">
            Please check {plural(invalidFields.length, '0 fields which have errors', '1 field which has an error', `${invalidFields.length} fields which have errors`)}.
        </div>}
    </>;
}

const submitLabel = (_submit, isSubmitting) => {
    if (isSubmitting && _submit.hideLabelWhileSubmitting) {
        return null;
    }

    return _submit.label ?? 'Submit';
}



export default Actions;
